import React from 'react';
export const ComparisonTable = () => {
  const comparisons = [{
    traditional: 'Same pressure throughout',
    elivara: 'Graduated pressure zones (strongest at ankle, gets lighter going up)'
  }, {
    traditional: 'Generic medical device',
    elivara: 'Made for lipedema'
  }, {
    traditional: 'One size fits all',
    elivara: "Tailored to lipedema's unique fat patterns"
  }, {
    traditional: 'Hard to put on, uncomfortable',
    elivara: 'Easy to wear, comfortable all day'
  }, {
    traditional: "Doesn't follow lymphatic paths",
    elivara: 'Maps directly to lymphatic drainage paths'
  }, {
    traditional: 'Looks obviously medical',
    elivara: 'Looks like stylish leggings'
  }, {
    traditional: 'Made for varicose veins',
    elivara: 'Built specifically for women with lipedema'
  }];
  return <>
      {/* Desktop table */}
      <div className="hidden sm:block overflow-x-auto" data-id="element-244">
        <table className="w-full border-collapse" data-id="element-245">
          <thead data-id="element-246">
            <tr data-id="element-247">
              <th className="border p-3 bg-gray-100 text-left" data-id="element-248">
                Traditional Compression Stockings
              </th>
              <th className="border p-3 bg-pink-100 text-left" data-id="element-249">
                Elivara FlowMapping™ Compression
              </th>
            </tr>
          </thead>
          <tbody data-id="element-250">
            {comparisons.map((item, index) => <tr key={index} data-id="element-251">
                <td className="border p-3" data-id="element-252">{item.traditional}</td>
                <td className="border p-3" data-id="element-253">{item.elivara}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Mobile comparison cards */}
      <div className="sm:hidden space-y-4" data-id="element-254">
        {comparisons.map((item, index) => <div key={index} className="border rounded-md overflow-hidden" data-id="element-255">
            <div className="bg-gray-100 p-3 font-medium text-sm" data-id="element-256">
              Traditional Compression:
            </div>
            <div className="p-3 border-b text-sm" data-id="element-257">{item.traditional}</div>
            <div className="bg-pink-100 p-3 font-medium text-sm" data-id="element-258">
              Elivara FlowMapping™:
            </div>
            <div className="p-3 text-sm" data-id="element-259">{item.elivara}</div>
          </div>)}
      </div>
    </>;
};